<div class="sq card-body">
<!--   <div
    style="
      position: absolute;
      top: 1px;
      right: 0px;
      z-index: 99999;
      cursor: pointer;
    "
    mat-button
    (click)="closeManifest2()"
    class=""
    cdkFocusInitial
  >
    <i class="material-icons">close</i>
  </div> -->
<div class="modal-header" style="text-align: center">
  <h3 class="modal-title" id="exampleModalScrollableTitle">
    <b *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'">Detailed Report</b>
    <b *ngIf="typeReport === 'PHYSICALDESTRUCTION'">Basic Report</b>
  </h3>
</div>

<div class="modal-body">
  <div class="material-datatables" *ngIf="reportID !== null && !loading">
    <table
      id="reportTable"
      class="table table-striped table-no-bordered table-hover"
      cellspacing="0"
      width="100%"
      style="width: 100%; overflow-x: auto; white-space: nowrap"
    >
      <thead>
        <tr>
          <th>PO</th>
          <th>User</th>
          <th>Type</th>
          <th>Status</th>
          <th>Date</th>
          <th class="text-right">Detail</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ report.pO }}</td>
          <td>{{ report.user.name }} {{ report.user.surname }}</td>
          <td>{{ reportType }}</td>
          <td *ngIf="report.name === 'pending'">PDR in Progress</td>
          <td *ngIf="report.name !== 'pending'">PDR Completed</td>
          <td *ngIf="report.name !== 'pending'">
            {{ report.dateReport.timestamp * 1000 | date : "MM-dd-yyyy" }}
          </td>
          <td *ngIf="report.name === 'pending'">-</td>
          <td class="text-right">
            <!-- <a
              class="btn btn-link btn-info btn-just-icon"
              (click)="downloadFile(report.id)"
              *ngIf="
                report.type === 'DATAERASUREREPORT' ||
                report.type === 'PHYSICALDESTRUCTION' ||
                report.type === 'PDTEMP' ||
                report.type === 'INBOUNDWEIGHTBYDATE' ||
                report.type === 'INBOUNDWEIGHTBYPO' ||
                report.type === 'DETAILEDPHYSICALDESTRUCTION'
              "
              ><i class="material-icons text-success"> cloud_download </i></a
            > -->
            <a
              class="btn btn-link btn-info btn-just-icon"
              (click)="openReport(report.id, report.type)"
              *ngIf="
                report.type === 'DATAERASUREREPORT' ||
                report.type === 'PHYSICALDESTRUCTION' ||
                report.type === 'PDTEMP' ||
                report.type === 'INBOUNDWEIGHTBYDATE' ||
                report.type === 'INBOUNDWEIGHTBYPO' ||
                report.type === 'DETAILEDPHYSICALDESTRUCTION'
              "
              ><i class="material-icons">remove_red_eye</i></a
            >

            <!-- <a
              *ngIf="canUnlock() && cerrado"
              class="btn btn-link btn-info btn-just-icon"
              (click)="unlock()"
              ><i class="material-icons">edit</i></a
            > -->

            <a
              *ngIf="canUnlock() && cerrado"
              (click)="unlock()"
              class="btn btn-link btn-warning btn-just-icon unlock"
              ><i class="material-icons">lock_open</i></a
            >

            <!--<a
              *ngIf="desbloqueando === report.id"
              class="btn btn-link btn-default btn-just-icon"
            >
              <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
            ></a>-->

            <a
              *ngIf="report.name === 'pending'"
              (click)="deleteFolderfirst(report.id)"
              class="btn btn-link btn-danger btn-just-icon"
              ><i class="material-icons"> delete_outline</i></a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <br />
  <!--<div class="row">
    <div class="col-12" style="text-align: right">
      <label *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'">Detailed</label>
      <label *ngIf="typeReport === 'PHYSICALDESTRUCTION'">Basic</label>
    </div>
  </div>-->
  <div>
    <form>
      <div>
        <mat-form-field class="example-full-width has-label" *ngIf="isDetailed">
          <mat-label>Make</mat-label>
          <input
            placeholder="Make"
            type="text"
            [(ngModel)]="this.destructionManuallyMake"
            name="detailedmake"
            [disabled]="cerrado"
            matInput
            required
          />
        </mat-form-field>
        <mat-form-field class="example-full-width has-label" *ngIf="isDetailed">
          <mat-label>Model</mat-label>
          <input
            placeholder="Model"
            type="text"
            [(ngModel)]="this.destructionManuallyModel"
            name="detailedmodel"
            [disabled]="cerrado"
            matInput
            required
          />
        </mat-form-field>
        <mat-form-field class="example-full-width has-label" *ngIf="isDetailed">
          <mat-label>Capacity</mat-label>
          <input
            placeholder="Capacity"
            type="text"
            [(ngModel)]="this.destructionManuallySerialCapacity"
            name="detailedcapacity"
            [disabled]="cerrado"
            matInput
          />
        </mat-form-field>
        <mat-form-field class="example-full-width has-label" *ngIf="isDetailed">
          <mat-label>Serial Number</mat-label>
          <input
            placeholder="Serial Number"
            type="text"
            [(ngModel)]="this.destructionManuallySerialNumber"
            name="detailedserialnumber"
            [disabled]="cerrado"
            matInput
            required
          />
        </mat-form-field>
        <mat-form-field class="example-full-width has-label" *ngIf="isDetailed">
          <mat-label>Parent</mat-label>
          <input
            placeholder="Parent"
            type="text"
            [(ngModel)]="this.destructionManuallyParent"
            name="detailedparent"
            [disabled]="cerrado"
            matInput
          />
        </mat-form-field>
        <form #f2="ngForm" *ngIf="!isDetailed">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="bmd-label-floating">Add Serial Numbers:</label>
                <div class="form-group">
                  <textarea
                    name="nuevoValue"
                    #notes="ngModel"
                    [(ngModel)]="nuevo.value"
                    class="form-control"
                    rows="3"
                    [disabled]="cerrado"
                    required
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="itemsID.length > 0"
            class="row d-flex justify-content-center"
          >
            <!-- Cuadro izquierdo -->
            <div class="custom-box orange-box full-width-box">
              <!-- Cuadro izquierdo -->
              <p class="items-error">
                <i
                  class="material-icons"
                  style="font-size: 16px; color: #c19a0a"
                  >warning</i
                >
                These serial numbers already exist in this report
              </p>

              <div class="items-error" *ngFor="let item of itemsID">
                {{ item }}
                <i
                  class="material-icons"
                  style="
                    font-size: 16px;
                    color: #ff0000;
                    margin-left: 5px;
                    cursor: pointer;
                  "
                  (click)="removeItemFromArray(item)"
                  >delete</i
                >
              </div>
            </div>
          </div>
        </form>
        <!--<div class="d-flex justify-content-end" *ngIf="!isDetailed">
          <button
            type="button"
            class="btn btn-danger"
            (click)="cleanValues()"
            [disabled]="((itemsID.length === 0 && itemsAdd.length === 0 ) && nuevo.value === '')"
          >
            Clean
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            class="btn btn-success"
            (click)="saveItem()"
            [disabled]="!f2.valid || savingItem"
          >
            <i *ngIf="savingItem" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            Save Changes
          </button>
        </div>-->
      </div>
      <div class="my-4 mb-10">
        <button
          *ngIf="!isDetailed"
          type="button"
          class="btn btn-danger"
          (click)="cleanValues()"
          [disabled]="itemsID.length === 0 && nuevo.value === ''"
        >
          Clean
        </button>
        &nbsp;&nbsp;
        <button
          *ngIf="
            !cerrado && poReport !== '' && poReport !== null && !isDetailed
          "
          type="button"
          class="btn btn-success"
          (click)="saveDestructionReport()"
          [disabled]="nuevo.value === '' || saving"
        >
          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          Add To Report
        </button>
        <button
          *ngIf="!cerrado && poReport !== '' && poReport !== null && isDetailed"
          [disabled]="
            saving ||
            !destructionManuallyMake ||
            !destructionManuallyModel ||
            !destructionManuallySerialNumber
          "
          class="btn btn-success mr-2"
          (click)="saveDestructionReport()"
        >
          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          &nbsp; Add To Report
        </button>
        &nbsp;&nbsp;
        <button
          *ngIf="
            this.responseDestructionReport.length > 0 &&
            this.poReport != '' &&
            !cerrado
          "
          class="btn btn-outline-success"
          (click)="generateDestructionReport()"
        >
          Generate Destruction Report
        </button>
      </div>
    </form>
  </div>

  <div *ngIf="responseDestructionReport.length >= 0" class="">
    <h4 class="font-weight-bold">
      #{{ total_items_count }} Elements for Destruction Report #{{
        this.poReport
      }}
    </h4>

    <button
      type="button"
      class="btn btn-danger"
      (click)="removeBulkModal()"
      [disabled]="bulk.length === 0"
    >
      Remove ({{ bulk.length }})
    </button>

    <dinamic-table
      *ngIf="!loadingDisks"
      [id]="'physicalReportTable'"
      [data]="destructionReport"
      [perPage]="perPage"
      [total_items_count]="total_items_count"
      [total_pages]="total_pages"
      [page]="page"
      (action_button)="action($event)"
      (buscar)="getReports($event)"
      [bulk]="bulk"
      (changeBulk)="changeBulk($event)"
    ></dinamic-table>

    <!--<table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th
            *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'"
            scope="col"
          >
            Make
          </th>
          <th
            *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'"
            scope="col"
          >
            Model
          </th>
          <th
            *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'"
            scope="col"
          >
            capacity
          </th>
          <th scope="col">Serial Number</th>
          <th scope="col">Destruction Method</th>
          <th scope="col">REP</th>
          <th scope="col" style="display: none">Date Destroyed</th>
          <th scope="col" style="text-align: right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of this.responseDestructionReport; index as i">
          <th scope="row">{{ i + 1 }}</th>
          <td *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'">
            {{ row.make || "" }}
          </td>
          <td *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'">
            {{ row.model || "" }}
          </td>
          <td *ngIf="typeReport === 'DETAILEDPHYSICALDESTRUCTION'">
            {{ row.capacity || "" }}
          </td>
          <td>{{ row.SerialNumber }}</td>
          <td>Shredded</td>
          <td>{{ row.user }}</td>
          <td style="display: none">{{ row.ErasureEndDate }}</td>
          <td style="text-align: right">
            <a
              class="btn btn-link btn-danger btn-just-icon"
              (click)="removeDisk(row.id)"
            >
              <i class="material-icons">delete</i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>-->

    <h4 class="font-weight-bold">Report Summary</h4>
    <ul>
      <li
        style="font-size: 1.2rem"
        *ngFor="let item of summaryResponse | keyvalue"
      >
        <b>{{ item.key }}</b
        >: <b>{{ item.value }}</b>
      </li>
    </ul>
  </div>

  <div
    *ngIf="reportSaved == 1"
    id="reportSaved"
    class="alert alert-info"
    role="alert"
  >
    <i style="color: white" class="material-icons">check</i> Report have been
    saved.
  </div>

  <!-- <button
    *ngIf="canUnlock() && cerrado"
    class="btn btn-danger"
    (click)="unlock()"
    [disabled]="saveunlock"
  >
    <i *ngIf="saveunlock" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    Unlock
  </button> -->
</div>
<div class="modal-footer" style="text-align: center">
  <button class="btn btn-danger btn-small" (click)="closeReport()">
    <i class="fa fa-reply" aria-hidden="true"></i> back
  </button>
</div>
